import { render, staticRenderFns } from "./editCube.vue?vue&type=template&id=00ceaff9&scoped=true&"
import script from "./editCube.vue?vue&type=script&lang=js&"
export * from "./editCube.vue?vue&type=script&lang=js&"
import style0 from "./editCube.vue?vue&type=style&index=0&id=00ceaff9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ceaff9",
  null
  
)

export default component.exports